import './birthdays';
import './permissions';


document.querySelector('.account-header .customer__birthday-add-close')?.addEventListener('click', function(){
    document.querySelector('.address-new-toggle').click();
});